module.exports = __webpack_public_path__ + "assets/img/2812.23df30f9.svg";